import { render } from "./SeeMoreCategories.vue?vue&type=template&id=56ba4604&scoped=true"
import script from "./SeeMoreCategories.vue?vue&type=script&lang=js"
export * from "./SeeMoreCategories.vue?vue&type=script&lang=js"

import "./SeeMoreCategories.vue?vue&type=style&index=0&id=56ba4604&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ba4604"]])

export default __exports__